import React, { useEffect, useRef, useState } from 'react'

import { Tooltip } from 'src/componentes'
import { AutenticacaoContainer } from 'src/componentes/autenticacao'
import { Botao } from 'src/componentes/botao'
import { Breadcrumb } from 'src/componentes/breadcrumb'
import { Cabecalho } from 'src/componentes/cabecalho'
import { ContainerAcoes } from 'src/componentes/container-acoes'
import { Filtro } from 'src/componentes/filtro'
import { IconeAlterar } from 'src/componentes/icones'
import {
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta
} from 'src/componentes/tabela'
import { InputUnform } from 'src/componentes/unform/input'
import { UsuarioParaImpersonateDTO } from 'src/dto'
import { Api } from 'src/servicos'
import { TipoOrdenacao } from 'src/tipos'

import {
  ModalConfirmacaoImpersonate,
  ModalConfirmacaoImpersonateRef
} from './componentes/modal-confirmacao'
import { Form, Container, Campo, Dados } from './styles'

interface DadosPesquisa {
  nome: string
  email: string
}

export const PaginaImpersonate: React.FC = () => {
  const tabelaRef = useRef<TabelaRef>()
  const modalRef = useRef<ModalConfirmacaoImpersonateRef>()
  const { iniciarImpersonate } = AutenticacaoContainer.useContainer()
  const [dadosPesquisa, definirDadosPesquisa] = useState<DadosPesquisa>(null)
  const [paginas, definirPaginas] = useState(null)

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisa) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  const confirmarImpersonate = async (usuario: UsuarioParaImpersonateDTO) => {
    const sucesso = await iniciarImpersonate(usuario.id)

    if (!sucesso) modalRef.current?.fechar()
  }

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }

    const dados = await Api.RequisitarUsuariosParaImpersonate(
      dadosPesquisa?.nome,
      dadosPesquisa?.email,
      numeroPaginas,
      quantidadePorPagina,
      chaveOrdenacao,
      ordem
    )

    if (!dados) return null
    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  return (
    <>
      <Cabecalho>
        <Breadcrumb
          titulo="Impersonate de Usuários"
          atalhos={[
            {
              texto: 'Sistema'
            },
            {
              texto: 'Impersonate'
            }
          ]}
        />
      </Cabecalho>
      <Filtro>
        <Form acaoSucesso={acaoPesquisa}>
          <Container>
            <Campo mr>
              <InputUnform
                type="text"
                name="nome"
                label="Nome"
                maxLength={200}
              />
            </Campo>
            <Campo>
              <InputUnform
                type="email"
                name="email"
                label="E-mail"
                maxLength={200}
              />
            </Campo>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <Tabela
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'email',
              Texto: 'E-mail',
              ComOrdenacao: true
            },
            {
              Chave: 'perfis',
              Texto: 'Perfis',
              Renderizar: (linha: TabelaDados) => (
                <>
                  {linha.perfis.map(
                    (p: string, i: number) => `${i > 0 ? ',' : ''} ${p}`
                  )}
                </>
              )
            },
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <Botao
                    type="button"
                    data-tip="Impersonar"
                    data-for={`${linha.id}-tooltip`}
                    elemento={IconeAlterar}
                    tema="CinzaClaro"
                    onClick={() =>
                      modalRef.current?.abrir(
                        (linha as unknown) as UsuarioParaImpersonateDTO
                      )
                    }
                  />
                  <Tooltip id={`${linha.id}-tooltip`} offset={{ top: 10 }} />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
      <ModalConfirmacaoImpersonate
        ref={modalRef}
        backdrop
        acaoPrimaria={confirmarImpersonate}
      />
    </>
  )
}
